export default context => {
  context.app.router.beforeEach((to, from, next) => {
    context.app.router['referrer'] = from
    next()
  })
}
